export default {"src":"/_next/static/media/design-director.b5eff830.svg","height":25,"width":23,"blurWidth":0,"blurHeight":0};